const config = {
  baseAPI: process.env.BASE_API_URL || "https://posttagapi3.com",
  baseAPIv2: process.env.BASE_API_V2 || "https://posttagapi3.com",
};
export default config;
